"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.suggestionsRequestSuccess = exports.suggestionsRequestError = exports.submit = exports.resultsRequestSuccess = exports.resultsRequestStarted = exports.resultsRequestError = exports.getSuggestions = exports.getResults = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getSearchData(endpoint) {
  return _RestHelper.default.get(endpoint);
}
// @TODO check why it was missing
var submit = exports.submit = function submit() {};
function parseSuggestions(searchData) {
  var getResults = function getResults(searchResults) {
    var tempSuggestions = [];
    Object.keys(searchResults).forEach(function (key) {
      return Object.keys(searchResults[key]).forEach(function (key2) {
        return tempSuggestions.push(searchResults[key][key2]);
      });
    });
    return tempSuggestions;
  };
  var extractSuggestions = function extractSuggestions() {
    var results = getResults(searchData);
    var array = results.map(function (item) {
      var suggestion = item && /<h1>(.*?)<\/h1>/g.exec(item)[1].toLowerCase();
      return suggestion;
    });
    var uniqueArray = array.filter(function (item, pos) {
      return item && array.indexOf(item) === pos;
    });
    return uniqueArray;
  };
  return extractSuggestions();
}
function parseResults(searchResults) {
  var parsedResults = searchResults.map(function (result) {
    var title = result.title,
      body = result.body,
      extension = result.extension,
      url = result.url;
    var parsedResult = {
      title: title,
      body: body && body.replace(/\s+/g, ' '),
      type: extension,
      url: url
    };
    return parsedResult;
  });
  return parsedResults;
}
var suggestionsRequestSuccess = exports.suggestionsRequestSuccess = function suggestionsRequestSuccess(dispatch, response) {
  dispatch({
    type: 'GET_SUGGESTIONS_SUCCESSFUL',
    data: {
      response: response.data,
      suggestions: parseSuggestions(response.data.highlighting)
    }
  });
};
var suggestionsRequestError = exports.suggestionsRequestError = function suggestionsRequestError(dispatch, error) {
  dispatch({
    type: 'GET_SUGGESTIONS_ERROR',
    data: {
      error: error
    }
  });
};
var resultsRequestStarted = exports.resultsRequestStarted = function resultsRequestStarted(dispatch) {
  dispatch({
    type: 'GET_RESULTS_STARTED'
  });
};
var resultsRequestSuccess = exports.resultsRequestSuccess = function resultsRequestSuccess(dispatch, response) {
  dispatch({
    type: 'GET_RESULTS_SUCCESSFUL',
    data: {
      response: response.data,
      results: parseResults(response.data.response.docs)
    }
  });
};
var resultsRequestError = exports.resultsRequestError = function resultsRequestError(dispatch, error) {
  dispatch({
    type: 'GET_RESULTS_ERROR',
    data: {
      error: error
    }
  });
};
var getSuggestions = exports.getSuggestions = function getSuggestions(dispatch, endpoint) {
  var resp = getSearchData(endpoint);
  return resp.then(function (response) {
    suggestionsRequestSuccess(dispatch, response);
  }).catch(function (err) {
    suggestionsRequestError(dispatch, err);
    console.error('getSuggestions', err); // eslint-disable-line no-console
  });
};
var getResults = exports.getResults = function getResults(dispatch, endpoint) {
  var resp = getSearchData(endpoint);
  resultsRequestStarted(dispatch);
  return resp.then(function (response) {
    resultsRequestSuccess(dispatch, response);
  }).catch(function (err) {
    resultsRequestError(dispatch, err);
    console.error('getResults', err); // eslint-disable-line no-console
  });
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case 'GET_SUGGESTIONS_SUCCESSFUL':
      {
        return _objectSpread(_objectSpread({}, state), action.data);
      }
    case 'GET_RESULTS_STARTED':
      {
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.data), {}, {
          isRequestPending: true
        });
      }
    case 'GET_RESULTS_SUCCESSFUL':
      {
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.data), {}, {
          isRequestPending: false
        });
      }
    default:
      return state;
  }
}